(function(){
  'use strict';

  function restoreDesktopMotionCss(){
    if (window.innerWidth <= 920) return;
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    Array.prototype.forEach.call(document.styleSheets, function(sheet){
      var rules;
      try { rules = sheet.cssRules; } catch (e) { return; }
      if (!rules) return;

      for (var i = 0; i < rules.length; i++){
        var media = rules[i];
        if (!media || media.type !== 4 || (media.conditionText || '').indexOf('prefers-reduced-motion') === -1) continue;

        for (var j = 0; j < media.cssRules.length; j++){
          var rule = media.cssRules[j];
          if (!rule || !rule.style) continue;

          var selector = (rule.selectorText || '').replace(/\s+/g, '');
          var animationDuration = parseFloat(rule.style.animationDuration || '');
          var transitionDuration = parseFloat(rule.style.transitionDuration || '');

          if (selector.indexOf('*') !== -1 &&
              ((isFinite(animationDuration) && animationDuration <= 0.01) ||
               (isFinite(transitionDuration) && transitionDuration <= 0.01))){
            rule.style.removeProperty('animation-duration');
            rule.style.removeProperty('animation-iteration-count');
            rule.style.removeProperty('transition-duration');
          }

          if (selector.indexOf('.r') !== -1 &&
              rule.style.opacity === '1' &&
              rule.style.transform === 'none'){
            rule.style.removeProperty('opacity');
            rule.style.removeProperty('transform');
          }
        }
      }
    });

    document.documentElement.classList.remove('reduced-motion');
  }

  restoreDesktopMotionCss();

  function qs(selector, scope){ return (scope || document).querySelector(selector); }

  /* ============================================================
     Custom branded variant dropdown. Replaces the native select
     visually so the OPEN list is themed, while keeping the real
     <select id="VarSel"> in the DOM (visually hidden) so all the
     existing price/stock/history logic keeps working unchanged.
     ============================================================ */
  function installVariantDropdown(){
    var select = qs('#VarSel');
    if (!select || select.dataset.vselBound === 'true') return;
    select.dataset.vselBound = 'true';

    // Hide the native select but keep it functional and focusable for a11y.
    select.style.position = 'absolute';
    select.style.width = '1px';
    select.style.height = '1px';
    select.style.opacity = '0';
    select.style.pointerEvents = 'none';
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');

    var wrap = document.createElement('div');
    wrap.className = 'vsel';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vsel__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var labelSpan = document.createElement('span');
    labelSpan.className = 'vsel__label';
    btn.appendChild(labelSpan);
    var caret = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    caret.setAttribute('viewBox', '0 0 24 24');
    caret.innerHTML = '<path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/>';
    btn.appendChild(caret);

    var list = document.createElement('ul');
    list.className = 'vsel__list';
    list.setAttribute('role', 'listbox');

    var options = Array.prototype.slice.call(select.options);
    options.forEach(function(opt, index){
      var li = document.createElement('li');
      li.className = 'vsel__opt';
      li.setAttribute('role', 'option');
      li.dataset.index = String(index);
      li.textContent = opt.textContent.trim();
      var disabled = opt.disabled || opt.getAttribute('data-avail') === 'false';
      li.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      li.setAttribute('aria-selected', opt.selected ? 'true' : 'false');
      list.appendChild(li);
    });

    function syncLabel(){
      var opt = select.options[select.selectedIndex];
      labelSpan.textContent = opt ? opt.textContent.trim() : '';
      Array.prototype.forEach.call(list.children, function(li){
        li.setAttribute('aria-selected', Number(li.dataset.index) === select.selectedIndex ? 'true' : 'false');
      });
    }

    function open(){
      wrap.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', onDocClick, true);
    }
    function close(){
      wrap.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onDocClick, true);
    }
    function onDocClick(e){ if (!wrap.contains(e.target)) close(); }

    btn.addEventListener('click', function(){
      if (wrap.classList.contains('open')) close(); else open();
    });

    list.addEventListener('click', function(e){
      var li = e.target.closest('.vsel__opt');
      if (!li || li.getAttribute('aria-disabled') === 'true') return;
      select.selectedIndex = Number(li.dataset.index);
      select.dispatchEvent(new Event('change', { bubbles: true }));
      syncLabel();
      close();
    });

    btn.addEventListener('keydown', function(e){
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp'){
        e.preventDefault();
        var dir = e.key === 'ArrowDown' ? 1 : -1;
        var i = select.selectedIndex;
        for (var step = 0; step < select.options.length; step++){
          i = (i + dir + select.options.length) % select.options.length;
          if (!select.options[i].disabled){ select.selectedIndex = i; break; }
        }
        select.dispatchEvent(new Event('change', { bubbles: true }));
        syncLabel();
      } else if (e.key === 'Enter' || e.key === ' '){
        e.preventDefault();
        if (wrap.classList.contains('open')) close(); else open();
      } else if (e.key === 'Escape'){ close(); }
    });

    // Keep custom label in sync if other code changes the select.
    select.addEventListener('change', syncLabel);

    wrap.appendChild(btn);
    wrap.appendChild(list);
    select.insertAdjacentElement('afterend', wrap);
    syncLabel();
  }

  function installExploreDesktopNavigation(){
    var section = qs('.explore-sec');
    var rail = section && qs('#explore-auto', section);
    if (!section || !rail) return;

    if (!qs('#PrayasaExploreDesktopNavStyle')){
      var style = document.createElement('style');
      style.id = 'PrayasaExploreDesktopNavStyle';
      style.textContent =
        '.explore-desktop-nav{display:none}' +
        '@media(min-width:921px){' +
          '.explore-sec{position:relative}' +
          '.explore-sec .explore-desktop-nav{' +
            'position:absolute;top:clamp(14px,2vw,26px);' +
            'right:max(24px,calc((100vw - 1440px)/2 + 52px));' +
            'z-index:12;display:flex;gap:10px;align-items:center' +
          '}' +
          '.explore-sec .explore-desktop-nav button{' +
            'width:46px;height:46px;border-radius:50%;display:flex;' +
            'align-items:center;justify-content:center;color:var(--maroon);' +
            'background:rgba(252,249,242,.96);' +
            'border:1px solid rgba(182,138,58,.38);' +
            'box-shadow:0 14px 30px -18px rgba(42,23,18,.4);' +
            'backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);' +
            'transition:background-color .3s var(--e),color .3s var(--e),' +
            'border-color .3s var(--e),box-shadow .3s var(--e),transform .3s var(--e)' +
          '}' +
          '.explore-sec .explore-desktop-nav button:hover{' +
            'color:#fff;background:var(--maroon);border-color:var(--maroon);' +
            'box-shadow:0 18px 36px -18px rgba(94,32,32,.5);transform:translateY(-2px)' +
          '}' +
          '.explore-sec .explore-desktop-nav button:active{transform:scale(.96)}' +
          '.explore-sec .explore-desktop-nav button:focus-visible{' +
            'outline:2px solid var(--orange);outline-offset:4px' +
          '}' +
          '.explore-sec .explore-desktop-nav svg{' +
            'width:17px;height:17px;fill:none;stroke:currentColor;stroke-width:1.8;' +
            'stroke-linecap:round;stroke-linejoin:round' +
          '}' +
        '}';
      document.head.appendChild(style);
    }

    if (qs('.explore-desktop-nav', section)) return;

    var nav = document.createElement('div');
    nav.className = 'explore-desktop-nav';
    nav.setAttribute('aria-label', 'Explore categories navigation');

    function makeButton(label, path, direction){
      var button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', label);
      button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + path + '"/></svg>';
      button.addEventListener('click', function(){
        var first = qs('.exp', rail);
        var styles = window.getComputedStyle(rail);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        var distance = (first ? first.getBoundingClientRect().width : 180) + gap;

        rail.dispatchEvent(new Event('mouseenter'));
        rail.scrollBy({ left: direction * distance, behavior: 'smooth' });
        window.setTimeout(function(){
          rail.dispatchEvent(new Event('mouseleave'));
        }, 650);
      });
      return button;
    }

    nav.appendChild(makeButton('Previous categories', 'M15 5l-7 7 7 7', -1));
    nav.appendChild(makeButton('Next categories', 'M9 5l7 7-7 7', 1));
    section.appendChild(nav);
  }

  function installBuyNow(){
    var form = qs('#PdpForm');
    var qtyRow = form && qs('.qtyrow', form);
    var atc = qs('#AtcBtn');
    if (!form || !qtyRow || !atc) return;

    var buy = qs('#BuyNowBtn');
    if (!buy){
      buy = document.createElement('button');
      buy.type = 'button';
      buy.id = 'BuyNowBtn';
      buy.className = 'pdp-buy-now';
      buy.textContent = 'Buy now';
      qtyRow.insertAdjacentElement('afterend', buy);
    }

    function sync(){
      var unavailable = !!atc.disabled;
      buy.disabled = unavailable;
      form.classList.toggle('is-soldout', unavailable);
    }

    if (buy.dataset.bound !== 'true'){
      buy.dataset.bound = 'true';
      buy.addEventListener('click', function(){
        if (buy.disabled) return;
        var old = qs('input[name="return_to"]', form);
        if (old) old.remove();
        var redirect = document.createElement('input');
        redirect.type = 'hidden';
        redirect.name = 'return_to';
        redirect.value = '/checkout';
        form.appendChild(redirect);
        HTMLFormElement.prototype.submit.call(form);
      });
    }

    if (atc.dataset.buySyncBound !== 'true'){
      atc.dataset.buySyncBound = 'true';
      new MutationObserver(sync).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
      var select = qs('#VarSel');
      if (select) select.addEventListener('change', function(){ window.setTimeout(sync, 0); });
    }
    sync();
  }

  function compactLongDescriptions(){
    var description = qs('.acx details:first-child');
    if (!description) return;
    var content = qs('.bd3', description);
    if (content && content.textContent.trim().length > 700) description.removeAttribute('open');
  }

  function boot(){
    installVariantDropdown();
    installExploreDesktopNavigation();
    installBuyNow();
    compactLongDescriptions();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
